export default "__VITE_ASSET__D3SfLGHF__"